
import axios from '@axios'

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(master_account => ({
        value: master_account.id,
        label: master_account.user,
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axios.get('v1/bridge/admin/master_account', { params })

      if (!data.success) {
        return []
      }

      commit('setData', data.data)
      return data
    },
    async add(_, params) {
      const { data } = await axios.post('v1/bridge/admin/master_account', params)

      return data
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/bridge/admin/master_account/${id}`, params)

      return data
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/bridge/admin/master_account/${id}`)

      return data
    },
    clear({ commit }) {
      commit('setData', [])
    }
  },
}
